import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import te from './te';

const LangContext = createContext(null);
const STORAGE_KEY = 'mt_admin_lang';

function readLang() {
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    if (v === 'te') return 'te';
  } catch { /* private browsing — fall through */ }
  return 'en';
}

export function LangProvider({ children }) {
  const [lang, setLangState] = useState(readLang);

  const setLang = useCallback((l) => {
    setLangState(l);
    try { localStorage.setItem(STORAGE_KEY, l); } catch { /* storage blocked */ }
  }, []);

  /**
   * t(englishString) — translate to Telugu when lang === 'te'.
   * Falls back to the English string if no Telugu translation is found,
   * so a missing key never renders undefined in the UI.
   */
  const t = useCallback((key) => {
    if (lang === 'te') return te[key] ?? key;
    return key;
  }, [lang]);

  const value = useMemo(() => ({ lang, setLang, t }), [lang, setLang, t]);

  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
}

/** Use inside any component to access { lang, setLang, t } */
export function useLang() {
  const ctx = useContext(LangContext);
  if (!ctx) throw new Error('useLang must be used inside <LangProvider>');
  return ctx;
}
